<template>
  <v-app-bar id="app-bar" app color="white" flat height="76" class="berkah-appbar">
    <v-btn
      class="mr-3 menu-toggle-btn"
      elevation="0"
      fab
      small
      @click="setDrawer(!drawer)"
    >
      <v-icon v-if="value" color="#018C74">mdi-view-quilt</v-icon>
      <v-icon v-else color="#018C74">mdi-menu</v-icon>
    </v-btn>

    <v-toolbar-title class="hidden-sm-and-down page-title" v-text="$route.name" />

    <v-spacer />

    <div class="search-box hidden-sm-and-down mr-4">
      <v-icon size="18" color="#9aa6a3" class="mr-2">mdi-magnify</v-icon>
      <input
        v-model="searchTerm"
        class="search-input"
        type="text"
        placeholder="Cari data, menu, dll..."
        @keyup.enter="onSearch"
      />
      <span class="search-shortcut">Ctrl /</span>
    </div>


    <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
      content-class="modern-menu"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-1 pr-2 pl-2 profile-pill"
          elevation="0"
          rounded
          v-bind="attrs"
          v-on="on"
        >
          <v-avatar size="36" class="mr-2 profile-avatar">
            <v-img src="/images/avatar.png" alt="Profile">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-icon size="18" color="#018C74">mdi-account</v-icon>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
          <div class="profile-text hidden-xs-only text-left">
            <div class="profile-name">
              {{ userData.nama_lengkap || userData.username || "Administrator" }}
            </div>
            <div class="profile-role">{{ userRole.role_name || "Super Admin" }}</div>
          </div>
          <v-icon size="18" color="#9aa6a3" class="ml-1">mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list width="220" class="pa-2">
        <v-list-item class="mb-2">
          <v-list-item-avatar color="#EAF6F3">
            <v-icon color="#018C74">mdi-shield-check</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              {{ userRole.role_name || "Super Admin" }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mb-2"></v-divider>

        <v-list-item :to="'/pages/edituser'" link>
          <v-list-item-icon class="mr-3">
            <v-icon size="20">mdi-account-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Profil Saya</v-list-item-title>
        </v-list-item>

        <v-list-item @click="logout" link class="logout-item">
          <v-list-item-icon class="mr-3">
            <v-icon size="20" color="red lighten-1">mdi-logout-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="red--text text--lighten-1 font-weight-medium">
            Keluar
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "DashboardCoreAppBar",
  props: {
    value: { type: Boolean, default: false },
  },
  data: () => ({
    searchTerm: "",
    notifCount: 3,
  }),
  computed: {
    ...mapState(["drawer"]),
    userRole() {
      try {
        const roleData = localStorage.getItem("userRole");
        return roleData ? JSON.parse(roleData) : { role_name: "Super Admin" };
      } catch (e) {
        return { role_name: "Super Admin" };
      }
    },
    userData() {
      try {
        const data = localStorage.getItem("userData");
        return data ? JSON.parse(data) : {};
      } catch (e) {
        return {};
      }
    },
  },
  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER",
    }),
    onSearch() {
    },
    onNotifClick() {
    },
    logout() {
      if (confirm("Anda yakin ingin mengakhiri sesi ini?")) {
        localStorage.removeItem("isLoggedIn");
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style scoped>
.berkah-appbar {
  border-bottom: 1px solid #eef1f0;
  box-shadow: 0 4px 16px rgba(1, 140, 116, 0.04) !important;
}

.menu-toggle-btn {
  background: #eaf6f3 !important;
  box-shadow: none !important;
}

.page-title {
  color: #1c2b28;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.search-box {
  display: flex;
  align-items: center;
  background: #f4f6f5;
  border: 1px solid #e7ebea;
  border-radius: 12px;
  padding: 8px 14px;
  width: 280px;
}

.search-input {
  border: none;
  outline: none;
  background: transparent;
  flex: 1;
  font-size: 0.85rem;
  color: #333;
}

.search-shortcut {
  background: white;
  border: 1px solid #e0e4e3;
  border-radius: 6px;
  font-size: 0.68rem;
  color: #9aa6a3;
  padding: 1px 6px;
}

.bell-btn {
  background: #f4f6f5;
}

.profile-pill {
  background: white !important;
  border: 1px solid #eef1f0 !important;
  text-transform: none !important;
}

.profile-avatar {
  border: 2px solid #eaf6f3;
}

.profile-text {
  line-height: 1.15;
}

.profile-name {
  font-weight: 700;
  font-size: 0.82rem;
  color: #1c2b28;
}

.profile-role {
  font-size: 0.68rem;
  color: #9aa6a3;
}

.modern-menu {
  border-radius: 12px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.logout-item:hover {
  background-color: #fff5f5 !important;
}

.v-list-item {
  transition: all 0.2s;
  border-radius: 8px;
}
</style>
